
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.874 12.75a1.16 1.16 0 00-.795.31c-.211.2-.33.47-.33.752 0 .391-.336.709-.75.709s-.75-.318-.75-.709c0-.657.277-1.288.769-1.753a2.706 2.706 0 011.856-.726h10.125c.414 0 .75.317.75.708 0 .391-.336.709-.75.709H2.874z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.874 2.125a1.16 1.16 0 00-.795.31c-.211.2-.33.47-.33.752v10.625c0 .282.119.552.33.752.21.199.497.31.795.31h9.375V2.125H2.874zm0-1.417h10.125c.414 0 .75.317.75.708v14.167c0 .391-.336.708-.75.708H2.874a2.706 2.706 0 01-1.856-.726 2.411 2.411 0 01-.769-1.753V3.187c0-.657.277-1.288.769-1.753A2.705 2.705 0 012.874.708z"}})])
          )
        }
      }
    